<template>
  <DefaultLayout :disableFacilitatorTools="true">

              <div class="container col-12" row row-grid align-items-center>
                Pelaajia:
                <base-input alternative v-model="numberOfPlayers" />

                <br />Nimen vähimmäispituus:
                <base-input alternative v-model="minNameLength" />

                <br />Nimen enimmäispituus:
                <base-input alternative v-model="maxNameLength" />

                <br />
                <base-button type="primary" v-on:click="onSubmit()"
                  >PÄIVITÄ</base-button
                >

                  <div class="col-12" ref="relationsholder">
                    <br />

                    <div v-if="showRelations">
                      <RelationsCytoscape
                        :key="relationsComponentKey"
                        :initialCanvasWidth="$refs.relationsholder.offsetWidth"
                        :selectedCaseNumber="1"
                      />
                    </div>
                  </div>
                </div>
  </DefaultLayout>
</template>

<script>
import Vue from "vue";
import RelationsCytoscape from "@/components/RelationsCytoscape.vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

export default {
  components: {
    RelationsCytoscape,
    DefaultLayout,
  },
  metaInfo: {
    meta: [
      {
        name: "viewport",
        content:
          "width=device-width, initial-scale=1, maximum-scale=5, user-scalable=1",
      },
    ],
  },
  data: function () {
    return {
      numberOfPlayers: 5,
      minNameLength: 5,
      maxNameLength: 15,
      showRelations: false,
      relationsComponentKey: 1,
    };
  },
  methods: {
    onSubmit() {
      let i = 0;
      const players = [];
      const nominations = [];
      for (i = 0; i < this.numberOfPlayers; i++) {
        const player = {};
        player.id = i;
        player.nick_name = this.generateName();
        players.push(player);

        const nomination = {};
        nomination.id = i;
        nomination.player = i;
        nomination.nominee = Math.floor(Math.random() * this.numberOfPlayers);
        nomination.case_number = 1;
        nominations.push(nomination);
      }

      this.$store.commit({
        type: "setAllPlayers",
        players: players,
      });

      this.$store.commit({
        type: "setNominations",
        nominations: nominations,
      });

      this.relationsComponentKey++;
      this.showRelations = true;
    },
    generateName() {
      let result = "";
      const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      const charactersLength = characters.length;

      const length =
        Math.floor(
          Math.random() * (this.maxNameLength - this.minNameLength + 1)
        ) + this.minNameLength;

      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    forceRerender() {
      this.componentKey += 1;
    },
  },
};
</script>
